import React from 'react';
import IconMaestro from '../../../assets/icons/IconPayments/IconMaestro';
import IconMasterCard from '../../../assets/icons/IconPayments/IconMasterCard';
import IconVisa from '../../../assets/icons/IconPayments/IconVisa';
import { PaymentTypesCard } from '../../../interfaces/PaymentTypesCard';
import {
  ButtonContainer,
  ButtonsWrapperEntry,
  ImgCard,
  OneClickButton,
} from '../../../pages/Entry/EntryStyledComponents';
import { TextBold, TextMedium } from '../../../styles/GlobalStyledComponents';
import Button from '../../Button/Button';
import { PromotionsData, StandardPaymentsData } from '../../../interfaces/Debt';

interface PaymentButtonsProps {
  cardList: any[];
  white: string;
  red4: string;
  textBold: number;
  paymentSelected: PromotionsData | StandardPaymentsData | undefined;
  isSelectedAmount?: boolean;
  quantity?: string;
  amountNotValid?: boolean;
  coLoanSelected?: boolean;
  isCo?: boolean;
  paymentClickButton?: boolean;
  handlePaymentClick: () => void;
  btnContinueDebtType: () => void;
  btnResetEntry?: () => void;
}

const PaymentButtons: React.FC<PaymentButtonsProps> = ({
  cardList,
  white,
  red4,
  textBold,
  paymentSelected,
  isSelectedAmount,
  quantity,
  amountNotValid,
  coLoanSelected,
  isCo,
  paymentClickButton,
  handlePaymentClick,
  btnContinueDebtType,
  btnResetEntry,
}) => {
  return (
    <ButtonContainer id="entry-payment-btn-container">
      {coLoanSelected && (
        <ButtonsWrapperEntry
          wrapperPadding="0 10px 0 0"
          id="payment-back-btn-wrapper"
        >
          <Button
            page={sessionStorage.getItem('flow') === 'co' ? '3' : '2'}
            color={red4}
            border={'2px'}
            borderColor={red4}
            backgroundColor={white}
            id="payment-back-btn"
            click={btnResetEntry!}
          >
            <TextBold fontSize={18} color={red4} lineHeight={20}>
              Vuelve al inicio
            </TextBold>
          </Button>
        </ButtonsWrapperEntry>
      )}
      {paymentClickButton && (
        <ButtonsWrapperEntry
          id="entry-payment-click-btn-wrapper"
          wrapperPadding="0 10px 0 0"
        >
          <OneClickButton
            id="entry-click-payment-btn"
            color={white}
            backgroundColor={red4}
            fontWeight={textBold}
            disabled={
              !paymentSelected ||
              (isSelectedAmount && (!quantity || amountNotValid))
            }
            gap="0px"
            onClick={handlePaymentClick}
          >
            <span>Paga en un click</span>
            <ImgCard id="entry-click-payment-btn-img">
              {cardList[0].type === PaymentTypesCard.MASTERCARD && (
                <IconMasterCard />
              )}
              {cardList[0].type === PaymentTypesCard.VISA && <IconVisa />}
              {cardList[0].type === PaymentTypesCard.MAESTRO && (
                <IconMaestro />
              )}
            </ImgCard>
            <TextMedium fontSize={14} color="white">
              ··· {cardList[0].last_four_digits}
            </TextMedium>
          </OneClickButton>
        </ButtonsWrapperEntry>
      )}
      <ButtonsWrapperEntry
        id="entry-payment-btn-wrapper"
        wrapperPadding="0 0 0 10px"
      >
        <Button
          id="entry-payment-btn"
          color={paymentClickButton ? red4 : white}
          border="2px"
          borderColor={red4}
          backgroundColor={paymentClickButton ? white : red4}
          fontWeight={textBold}
          disabled={
            (!paymentSelected &&  (isCo && !coLoanSelected)) ||
            (isSelectedAmount && (!quantity || amountNotValid))
          }
          click={btnContinueDebtType}
        >
          <span>Elegir forma de pago</span>
        </Button>
      </ButtonsWrapperEntry>
    </ButtonContainer>
  );
};

export default PaymentButtons;
